import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const WinkyDefaultIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.42825 0.599998H1.71423V3.17134L1.71434 3.17134V11.7425V15.1709H9.42836V11.7425H9.42832V3.17134L9.42825 3.17134V0.599998ZM7.71409 3.17134H5.99991V11.7425H7.71409V3.17134ZM22.2849 0.599998H14.5709V3.17134L14.5709 3.17134V11.7425V15.1709H22.2849V11.7425V3.17134L22.2849 3.17134V0.599998ZM20.5707 3.17134H18.8564V11.7425H20.5707V3.17134ZM7.71402 16.8851H0V18.5994H7.71402V16.8851ZM9.42865 16.8851H14.5713V18.5994H9.42865V16.8851ZM14.5713 22.0278H12.8571V23.7421H14.5713V22.0278ZM9.42865 22.0278H11.1429V23.7421H9.42865V22.0278ZM7.71402 20.3136H0V22.0278H7.71402V20.3136ZM16.2855 16.8847H23.9996V18.599H16.2855V16.8847ZM12.8571 18.5994V22.0278H11.1429V18.5994H12.8571ZM24 20.3136H16.286V22.0278H24V20.3136Z"
        fill="#FFBDBB"
      />
    </Icon>
  );
};
